import { api } from "@/api"
import type { MaybeRef } from "@vueuse/core"
import { useQuery } from "@tanstack/vue-query"
import type { ReportQuery } from "./reportQuery"

export type SummaryReport = {
  orderCount: {
    total: number
    cash: number
    card: number
  }
  revenue: {
    total: number
    cash: number
    card: number
  }
}

export type SummaryReportQuery = ReportQuery & {
  sources?: ("sale" | "donation" | "unlinked")[]
}

const retrieveSummaryReport = async (
  query: SummaryReportQuery
): Promise<SummaryReport> => {
  const { body } = await api.get<SummaryReport>(
    "/reports/summary/",
    {
      query: query,
    }
  )
  return body
}

export const useSummaryReport = (
  query: MaybeRef<SummaryReportQuery>
) =>
  useQuery(
    [BASE_SUMMARY_REPORT_QUERY_KEY, query] as const,
    ({ queryKey: [_name, query_] }) =>
      retrieveSummaryReport(unref(query_)),
    { refetchInterval: 60 * 1000 }
  )
